import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCC } from '../../contexts/CCContext';
import { classLabel } from './contract';
import CCPublicationLegend from './CCPublicationLegend';
import { useYield } from './YieldContext';
import { YieldLegend } from './YieldPanel';

export default function CCLegend() {
  const cc = useCC();
  const yieldView = useYield();
  if (yieldView?.view === 'yield') return <YieldLegend />;
  if (cc.transport === 'v2') return <CCPublicationLegend />;
  return <LegacyCCLegend />;
}

function LegacyCCLegend() {
  const { metadata, dataset } = useCC();
  const { t } = useTranslation('translation');
  if (!metadata || !dataset) return null;
  return <div className="cc-legend" aria-label={t('cc.legend')}>
    <strong>{t('general.crop_intelligence')} · {dataset.year}</strong>
    <div className="cc-legend-items">
      {Object.values(metadata.classes).map((entry) => <span key={entry.code}>
        <i style={{ backgroundColor: entry.fill, borderColor: entry.stroke }} />
        {classLabel(metadata, entry.code, t)}
      </span>)}
      <span><i style={{ backgroundColor: metadata.unmapped.fill, borderColor: metadata.unmapped.stroke }} />
        {t(metadata.unmapped.label_key, { defaultValue: metadata.unmapped.name })}</span>
    </div>
  </div>;
}
